import React, { useState, useEffect } from "react";
import ModalViewSelectedOffer from "./ModalViewSelectedOffer";
import translations from "../../../utils/language/translations.json";
import { useTranslation } from "react-i18next";
import PaginationComponentGridSold from "./PaginationComponentGridSold";
import ModalTradeOffer from "./ModalTradeOffer";
import { useNavigate } from "react-router-dom";

const GridTradeOffer = ({
  tradeOffers,
  userId,
  Status,
  liveCsrfToken,
  fetchTradeOffers,
  preSelectedTransaction
}) => {
  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.GridSoldOrOffer?.[key]?.[currentLang] || key;
  const [isTradeModalOpen, setIsTradeModalOpen] = useState(false);
  const [openTradeId, setOpenTradeId] = useState(preSelectedTransaction>0?preSelectedTransaction:null);
 const [selectedOffer, setSelectedOffer] = useState(null);
 const [selectedTheirId, setSelectedTheirId] = useState(null);
  const [sortValue, setSortValue] = useState("dateReceivedDesc");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
const [isMobile, setIsMobile] = useState(false);
const navigate = useNavigate();
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
  
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // Group data by tradeId
  const groupedData = Object.values(
    tradeOffers.reduce((acc, object) => {
      const tradeId = object.tradeId;
      acc[tradeId] = acc[tradeId] || [];
      acc[tradeId].push(object);
      return acc;
    }, {})
  );

  // Sorting logic
  useEffect(() => {
    setCurrentPage(1);
  }, [tradeOffers]);

  const sortedGroups = [...groupedData].sort((a, b) => {
    const dateA = new Date(a[0].Date);
    const dateB = new Date(b[0].Date);
    switch (sortValue) {
      case "dateReceivedAsc":
        return dateA - dateB;
      case "dateReceivedDesc":
        return dateB - dateA;
      default:
        return 0;
    }
  });

  const totalPages = Math.ceil(sortedGroups.length / itemsPerPage);
  const paginatedGroups = sortedGroups.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

  return (
    <div className="grid-sold-offer">
      <h3>
        {Status === "Waiting" || Status === "Counter"
          ? t("Answer Now")
          : t(Status)}
      </h3>
      <label>{t("Sort by")}: </label>
      <select value={sortValue} onChange={(e) => setSortValue(e.target.value)}>
        <option value="dateReceivedDesc">
          {t("Date Received (Newest to Oldest)")}
        </option>
        <option value="dateReceivedAsc">
          {t("Date Received (Oldest to Newest)")}
        </option>
      </select>

      {paginatedGroups.map((group, index) => {
        const receiving = group.filter((g) => g.transactionType === "Offering");
        const giving = group.filter((g) => g.transactionType === "Wanted");
        const displayDataOffering = receiving[0];
        const displayDataGiving = giving[0];
const tradeId = displayDataOffering?.tradeId || displayDataGiving?.tradeId;
        const offerUserId =
          displayDataOffering?.offerUserId || displayDataGiving?.offerUserId;
        const wantedUserId =
          displayDataOffering?.wantedUserId || displayDataGiving?.wantedUserId;
        const isViewerTheWanted = userId === wantedUserId;
        const theirIdValidated = isViewerTheWanted ? offerUserId : wantedUserId;

        console.log("receiving", receiving);
        console.log("giving", giving);
        console.log("displayDataOffering", displayDataOffering);
        console.log("displayDataGiving", displayDataGiving);
        const offerData = group.filter((g) => g.transactionType === "Offering");
        const wantedData = group.filter((g) => g.transactionType === "Wanted");

        const offerObject = {
          offerData,
          wantedData,
          offerCash: offerData[0]?.offerCash || wantedData[0]?.offerCash || 0,
          wantedCash:
            wantedData[0]?.wantedCash || offerData[0]?.wantedCash || 0,
          comments: offerData[0]?.comments || wantedData[0]?.comments || "",
        };

        return (
          <React.Fragment key={index}>
          {!isMobile?(<>
                <div key={index} className="transaction-card trade-style-option-a"  onClick={()=>{setOpenTradeId(tradeId);setSelectedOffer(offerObject);setSelectedTheirId(theirIdValidated);}}>
<h4>{displayDataOffering?.Status}</h4>
          <div className="transaction-details">
            <p className="received-on">{formatDate(displayDataOffering?.Date||displayDataGiving?.Date)}</p>
            <p>{t('Trade ID')}#{displayDataOffering?.tradeId||displayDataGiving?.tradeId}</p>
          </div>

          <div className="user-info-row">

            <div className="user-info-col" style={{cursor:'pointer'}} onClick={(e) =>{ e.stopPropagation();navigate(`/ViewUserProfil/${displayDataOffering?.OfferShowName || displayDataGiving?.OfferShowName ||'Invalid User'}`)}}>
              <img className='avatar Bigger' src={displayDataOffering?.OfferProfilePicture ||displayDataGiving?.OfferProfilePicture|| '/default-avatar.png'} alt="User 1"  />
              <p className="username">{displayDataOffering?.OfferShowName || displayDataGiving?.OfferShowName ||'Invalid User'}</p>
              <p className="rating">({displayDataOffering?.OfferTransactions || displayDataGiving?.OfferTransactions ||0}) {(displayDataOffering?.OfferRating * 20 ||displayDataGiving?.OfferRating * 20 ||  0).toFixed(0)}%</p>
            </div>
          </div>

                  <div className="card-preview-row">

                    {offerObject?.offerCash > 0 && (
            <div className="cash-summary">
              {" "}
              <span
                className={`cash-amount ${
                  isViewerTheWanted ? "cash-positive" : "cash-negative"
                }`}
              >
                {isViewerTheWanted ? "+" : "-"}${Math.abs(offerObject.offerCash)}
              </span>
            </div>
          )}

          <div className="card-preview">
            <div className="image-container">
              <img
                src={displayDataOffering?.ImageFront|| displayDataOffering?.Image || require("../../../assets/istockphotoImageComingSoon.jpg")}
                alt={`Card ${0}`}
                className="card-img"
              />
              <div className="card-count">{receiving?.length||0}</div>
            </div>
            </div>

                    <div className="vs-label">VS</div>

          <div className="card-preview">
            <div className="image-container">
              <img
                src={displayDataGiving?.ImageFront|| displayDataGiving?.Image || require("../../../assets/istockphotoImageComingSoon.jpg")}
                alt={`Card ${0}`}
                className="card-img"
              />
              <div className="card-count">{giving?.length||0}</div>
            </div>
            </div>

                    {offerObject?.wantedCash > 0 && (
            <div className="cash-summary">
              {" "}
              <span
                className={`cash-amount ${
                  !isViewerTheWanted ? "cash-positive" : "cash-negative"
                }`}
              >
                {!isViewerTheWanted ? "+" : "-"}${Math.abs(offerObject.wantedCash)}
              </span>
            </div>
          )}
                  </div>

          <div className="user-info-row">
          <div className="user-info-col" style={{cursor:'pointer'}}onClick={(e) =>{ e.stopPropagation();navigate(`/ViewUserProfil/${displayDataOffering?.WantedShowName || displayDataGiving?.WantedShowName ||'Invalid User'}`)}}>
              <img className='avatar Bigger' src={displayDataGiving?.WantedProfilePicture ||displayDataOffering?.WantedProfilePicture || '/default-avatar.png'} alt="User 2" />
              <p className="username">{displayDataOffering?.WantedShowName || displayDataGiving?.WantedShowName ||'Invalid User'}</p>
              <p className="rating">({displayDataGiving?.WantedTransactions ||displayDataOffering?.WantedTransactions|| 0}) {(displayDataGiving?.WantedRating * 20 ||displayDataOffering?.WantedRating * 20|| 0).toFixed(0)}%</p>
            </div>
            </div>

   
                </div>
 
        </>): (<>
       
 <div className="transaction-wrapper">
          <div key={index} className="transaction-card trade-style-option-a" onClick={()=>{setOpenTradeId(tradeId);setSelectedOffer(offerObject);setSelectedTheirId(theirIdValidated);}}>
              <h4>{displayDataOffering?.Status}</h4>
            <div className="transaction-details">
              <p className="received-on">
                {t("Trade ID")}#
                {displayDataOffering?.tradeId || displayDataGiving?.tradeId}{" "}
                
                {formatDate(
                  displayDataOffering?.Date || displayDataGiving?.Date
                )}
              </p>
            </div>

            <div className="top-row">
              <div className="user-info-row">
                <div className="user-info-col">
                  <img
                    className="avatar Bigger"
                    src={
                      displayDataOffering?.OfferProfilePicture ||
                      displayDataGiving?.OfferProfilePicture ||
                      "/default-avatar.png"
                    }
                    alt="User 1"
                  />
                  <p className="username">
                    {displayDataOffering?.OfferShowName ||
                      displayDataGiving?.OfferShowName ||
                      "Invalid User"}
                  </p>
                  <p className="rating">
                    (
                    {displayDataOffering?.OfferTransactions ||
                      displayDataGiving?.OfferTransactions ||
                      0}
                    ){" "}
                    {(
                      displayDataOffering?.OfferRating * 20 ||
                      displayDataGiving?.OfferRating * 20 ||
                      0
                    ).toFixed(0)}
                    %
                  </p>
                </div>
              </div>

              <div className="user-info-row">
                <div className="user-info-col">
                  <img
                    className="avatar Bigger"
                    src={
                      displayDataGiving?.WantedProfilePicture ||
                      displayDataOffering?.WantedProfilePicture ||
                      "/default-avatar.png"
                    }
                    alt="User 2"
                  />
                  <p className="username">
                    {displayDataOffering?.WantedShowName ||
                      displayDataGiving?.WantedShowName ||
                      "Invalid User"}
                  </p>
                  <p className="rating">
                    (
                    {displayDataGiving?.WantedTransactions ||
                      displayDataOffering?.WantedTransactions ||
                      0}
                    ){" "}
                    {(
                      displayDataGiving?.WantedRating * 20 ||
                      displayDataOffering?.WantedRating * 20 ||
                      0
                    ).toFixed(0)}
                    %
                  </p>
                </div>
              </div>
            </div>

            <div className="middle-row">
              <div className="card-preview">
                <div className="image-container">
                  <img
                    src={
                      displayDataOffering?.ImageFront ||
                      displayDataOffering?.Image ||
                      require("../../../assets/istockphotoImageComingSoon.jpg")
                    }
                    alt={`Card ${0}`}
                    className="card-img"
                  />
                  <div className="card-count">{receiving?.length || 0}</div>
                </div>
              </div>
              <div className="vs-label">VS</div>

              <div className="card-preview">
                <div className="image-container">
                  <img
                    src={
                      displayDataGiving?.ImageFront ||
                      displayDataGiving?.Image ||
                      require("../../../assets/istockphotoImageComingSoon.jpg")
                    }
                    alt={`Card ${0}`}
                    className="card-img"
                  />
                  <div className="card-count">{giving?.length || 0}</div>
                </div>
              </div>
            </div>

            {(offerObject.offerCash > 0 || offerObject.wantedCash > 0) && (
              <div className="cash-row">
                {offerObject?.offerCash > 0 && (
                  <div className="cash-summary">
                    {" "}
                    <span
                      className={`cash-amount ${
                        isViewerTheWanted ? "cash-positive" : "cash-negative"
                      }`}
                    >
                      {isViewerTheWanted ? "+" : "-"}$
                      {Math.abs(offerObject.offerCash)}
                    </span>
                    
                  </div>
                )}

                {offerObject?.wantedCash > 0 && (
                  <div className="cash-summary">
                    {" "}
                    <span
                      className={`cash-amount ${
                        !isViewerTheWanted ? "cash-positive" : "cash-negative"
                      }`}
                    >
                      {!isViewerTheWanted ? "+" : "-"}$
                      {Math.abs(offerObject.wantedCash)}
                    </span>
                  </div>
                )}
                
              </div>
            )}
            
          </div>
          
  <div className="view-button-container">

  </div>
</div> 
       </> 
      )}
      </React.Fragment>);
      })}
      
      
          
     {openTradeId && (
  <ModalTradeOffer
    key={openTradeId}                 // force remount when trade changes
    isOpen={true}
    onClose={() => { setOpenTradeId(null); }}
    mode="view"
    yourId={userId}
    theirId={selectedTheirId}
    offer={selectedOffer}
    fetchTradeOffers={fetchTradeOffers}
    Status={Status}
  />
)}

      {totalPages > 1 && (
        <PaginationComponentGridSold
          totalPages={totalPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}
    </div>
  );
  
};

export default GridTradeOffer;

{
  /* {paginatedGroups.map((group, index) => {
        const receiving = group.filter(g => g.transactionType === 'Offering');
        const giving = group.filter(g => g.transactionType === 'Wanted');
        const displayData = receiving.length > 0 ? receiving[0] : giving[0];

        return (
          <div key={index} className="transaction-card">
            <div className="transaction-details">
              <p className="received-on">{t('Received On')} {formatDate(displayData.Date)}</p>
              <p>{t('Trade ID')}#{displayData.tradeId}</p>
            </div>

            <div className="card-preview">
              <div className="image-container">
                <img
                  src={receiving[0]?.usercardsImageFront || receiving[0]?.cardsImage || '/placeholder-image.png'}
                  alt="Receiving"
                  className="card-img"
                />
                <div className="card-count">{receiving.length}</div>
              </div>
              <div style={{ padding: '0 20px' }}><strong>VS</strong></div>
              <div className="image-container">
                <img
                  src={giving[0]?.usercardsImageFront || giving[0]?.cardsImage || '/placeholder-image.png'}
                  alt="Giving"
                  className="card-img"
                />
                <div className="card-count">{giving.length}</div>
              </div>
            </div>
          
<ModalTradeOffer
  isOpen={isTradeModalOpen}
  onClose={() => setIsTradeModalOpen(false)}
  mode="view"
  offer={group} 
/>
            {/* <ModalViewSelectedOffer
              receiving={receiving}
              giving={giving}
              onClose={() => {}}
              Status={Status}
              liveCsrfToken={liveCsrfToken}
            /> 
          </div>
        );
      })} */
}
